import { render, staticRenderFns } from "./LeadTimeAdd.vue?vue&type=template&id=5981adcf&scoped=true"
import script from "./LeadTimeAdd.vue?vue&type=script&lang=js"
export * from "./LeadTimeAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5981adcf",
  null
  
)

export default component.exports